// extracted by mini-css-extract-plugin
export default {"wysiwygContainer":"styles__wysiwygContainer___6FDSQ","charcounts":"styles__charcounts___VxD1m"};